import { expVal } from '@atlassian/jira-feature-experiments';

const AiGeneratedWorkItemNextActionsM2RelayProvider = {
	get(): boolean {
		return expVal('proactive_ai-generated_next_best_actions', 'isEnabled', false);
	},
};

export default AiGeneratedWorkItemNextActionsM2RelayProvider;
